import React, { Component } from 'react';
import FontAwesomeIcon from 'react-fontawesome';
import './SearchBar.css';

class SearchBar extends Component {
  constructor() {
    super();
    this.state = {
      query: '',
    }
  }

  componentDidMount() {
    if(this.props.shouldFocus) {
      this.search.focus();
    }
  }

  _handleInputChange = () => {
    this.props.searchFunction(this.search.value);
  }

  render() {
    return (
      <div className="searchContainer">
        <FontAwesomeIcon
          name='search' />
        <form className="formContainer">
          <input
            className="textInput"
            ref={input => this.search = input}
            onChange={this._handleInputChange}
            value={this.props.searchValue}
            type="text" />
        </form>
      </div>
    )
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.js